import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcProvisioning = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M11.25 12.25H6A1.75 1.75 0 0 0 4.25 14v2h1.5v-2a.25.25 0 0 1 .25-.25h11.5a.25.25 0 0 1 .25.25v2h1.5v-2a1.75 1.75 0 0 0-1.75-1.75h-4.75V10h-1.5v2.25Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M16 6.063V6a3 3 0 0 0-5.41-1.786 1.75 1.75 0 0 0-2.563 1.842A2 2 0 0 0 8.5 10h7a2 2 0 0 0 .5-3.937Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M2 18a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2Zm14 0a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2Z",
  fill: "var(--mds-nav-icon-medium)"
})), "IcProvisioning");

export { IcProvisioning };
//# sourceMappingURL=ic-provisioning.js.map
